import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import I18n from 'I18n';
import getLang from 'I18n/utils/getLang';
import PortalIdParser from 'PortalIdParser';
import { profilesAppClient, profilesPublicClient } from '../../common/clients/profilesClient';
import { TYPEAHEAD_SEARCH_RESULTS_LIMIT } from '../../constants/search';
import ProfileSearchBarResult from '../components/ProfileSearchBarResult';
// TODO refactor
export function getSolutionsDirectoryUrl(appContext) {
  let urlRoot;

  if (appContext === 'app') {
    urlRoot = `${getFullUrl('app')}/ecosystem/${PortalIdParser.get()}`;
  } else {
    urlRoot = getFullUrl('ecosystem', {
      hubletOverride: 'na1'
    });
    const lang = getLang();

    switch (lang) {
      case 'de':
      case 'es':
      case 'fr':
      case 'ja':
      case 'pt':
        {
          urlRoot += `/${lang}`;
          break;
        }

      default:
        break;
    }
  }

  return `${urlRoot}/marketplace/solutions`;
}
export function useProfileSearchBarQuery({
  appContext = 'app',
  grouped = false,
  limit = TYPEAHEAD_SEARCH_RESULTS_LIMIT,
  query = {}
} = {}, isUngatedForHomepage) {
  const fetcher = useCallback(input => {
    const client = appContext === 'public' ? profilesPublicClient : profilesAppClient;
    const request = client.post('profiles/search', {
      data: [Object.assign({}, query, {
        limit,
        search: input
      })]
    });
    return request.then(([{
      items,
      total
    }]) => {
      const options = items.map(item => {
        const {
          id,
          logoUrl,
          name,
          description,
          partnerType,
          reviewSummary,
          slug,
          tier
        } = item;
        return {
          dropdownText: /*#__PURE__*/_jsx(ProfileSearchBarResult, {
            description: description,
            isUngatedForHomepage: isUngatedForHomepage,
            logoUrl: logoUrl,
            name: name,
            partnerType: partnerType,
            reviewSummary: reviewSummary,
            searchTerm: input,
            tier: tier
          }),
          href: `${getSolutionsDirectoryUrl(appContext)}/${slug}`,
          item,
          linkUse: 'unstyled',
          text: name,
          value: `profile::${id}`
        };
      });

      if (total > limit) {
        options.push({
          href: `${getSolutionsDirectoryUrl(appContext)}${isUngatedForHomepage ? '/all' : ''}?eco_search=${input}`,
          text: I18n.text('ecosystemMarketplaceCore.solutions.profileSearchBarViewAll', {
            total
          }),
          value: '__VIEW_ALL_PROFILES__'
        });
      }

      return options;
    }).then(options => grouped ? [{
      text: I18n.text('ecosystemMarketplaceCore.solutions.profileSearchBarGroupLabel'),
      options
    }] : options);
  }, [appContext, grouped, isUngatedForHomepage, limit, query]);
  return {
    fetcher
  };
}